export default class TabMenu {

    constructor(element, options) {


        this.options = options;

        this.init(element);
        this.watch();
    }


    init(element) {
        console.log("initiating");
        this.element = element;
        this.elementId = element.id;
        this.tabs = this.findAsArray(this.element, 'label[role="tab"]');
        this.selectedTab = this.element.querySelector('label[role="tab"].selected');
        if (this.selectedTab) {
            this.selectedTab.focus();
        }
        this.panels = this.findAsArray(this.element, '[role="tabpanel"]');
    }

    refresh() {
        this.init();
    }

    watch() {
        var self = this;

        this.tabs.forEach(el => el.addEventListener("keydown", self.onTabKeydown.bind(self)));

    }

    focusOnTab() {
        var self = this;
        this.selectedTab = this.element.querySelector('label[role="tab"].selected');
    
        if (this.selectedTab && window.document.activeElement == window.document.body) {
            this.selectedTab.focus();

            this.init(this.element);
            this.tabs.forEach(el => el.addEventListener("keydown", self.onTabKeydown.bind(self)));

        }

    }

    onAddTabMenu(node) {
        //console.log("add: ", {"node.id": node.id, "this.elementId": this.elementId});
        if (node.id == this.elementId || node == this.element) {
            console.log("added");
            this.init(node);
        }
    };

    onRemoveTabMenu(node) {
        if (node.id == this.elementId || node == this.element) {
            console.log("removed");
        }
    };

    findAsArray(ele, selector) {
        var col = ele.querySelectorAll(selector);
        return Array.prototype.slice.call(col);
    }

    onTabKeydown(e) {
        console.log("test");
        let index = Array.prototype.indexOf.call(this.tabs, e.currentTarget);
        let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
        if (dir !== null) {
            e.preventDefault();
            console.log(this.panels, index);
            dir === 'down' ? this.panels[index].focus() : this.tabs[dir] ? this.switchTab(e.currentTarget, this.tabs[dir]) : void 0;
        }
    }

    switchTab(oldTab, newTab) {
        newTab.click();
        newTab.focus();
    }

}

TabMenu.DEFAULTS = {};


// WEBPACK FOOTER //
// ./project/client/src/core/components/tabmenu/tabmenu.js